import Glider from 'glider-js';
import debounce from 'lodash.debounce';

export const init = ($target) => {
	const jsExampleCarousel = $target.find('.js-example-carousel');
	let gliders = [];
	let initedExamples = [];
	Array.from(jsExampleCarousel).forEach((item, i) => {
		gliders.push(null);
		initedExamples.push(false);
	});

	const initCarousel = () => {
		const jsExampleCarousel = $target.find('.js-example-carousel');
		Array.from(jsExampleCarousel).forEach((item, i) => {
			const dots = $(item).next('.dots')[0];
			gliders[i] = new Glider(item, {
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: true,
				scrollLock: true,
				dots: dots,
				responsive: [
					{
						breakpoint: 750,
						settings: {
							dots: false,
						},
					},
				],
			});
			initedExamples[i] = true;
		});
	};

	const resizeHandler = () => {
		// console.log('resized!');
		const shouldInit = matchMedia('(max-width: 750px)').matches;
		if (shouldInit) {
			initCarousel();
			// console.log('inited!');
		} else if (!shouldInit) {
			gliders.forEach((glider, i) => {
				if (glider) glider.destroy();
				gliders[i] = null;
				initedExamples[i] = false;
			});
			// console.log('destroyed!');
		}
	};

	resizeHandler();
	$(window).on('resize', debounce(resizeHandler, 500));
	$(document).on('click', '.js-tabs-link', () => {
		setTimeout(() => {
			resizeHandler();
			gliders.forEach((glider, i) => {
				if (glider) glider.refresh();
			});
		}, 500);
	});
};
